import { Component, OnInit, ChangeDetectorRef, HostBinding } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SharedService, MetaService } from './../../services';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  constructor(
    private titleService: Title,
    private _shared: SharedService,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private _meta: MetaService
  ) {
    this.titleService.setTitle('Pogoda.by | Главная');
  }

  haveFactWidget;
  haveLevelWidget;
  haveHydroStormWidget;
  isSmallScreen = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
  isMobileAds = this.breakpointObserver.isMatched('screen and (max-width: 788px)');
  isTabletAds = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');
  isSmallHeader = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
  heightHeaderBig = '26px - 49px';
  heightHeaderSmall = '64px';

  // @HostBinding('style.height') height = 'calc(100vh - 71px - 50px)';
  @HostBinding('style.height') height = `calc(100vh - ${this.isSmallHeader ? this.heightHeaderSmall : this.heightHeaderBig})`;
  @HostBinding('style.paddingTop') paddingTop = `0px`;
  haveStorm;
  haveHydroStorm;

  showVideo = false;


  // ngAfterViewChecked() {
  ngAfterViewInit() {
    this._shared.currentFooterHeight.subscribe(state => {
      this.isSmallScreen = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
      this.isMobileAds = this.breakpointObserver.isMatched('screen and (max-width: 788px)');
      this.isTabletAds = this.breakpointObserver.isMatched('screen and (max-width: 1044px)');
      // this.height = `calc(100vh ${!this.isSmallScreen ? `- 71px - 50px ${this.haveStorm ? '- 40px' : ''} ${this.haveHydroStorm ? '- 40px' : ''}` : '- 64px'})`;
      this.isSmallHeader = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
    });
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this._meta.update(this.route.snapshot.data);
    this._shared.currentStorm.subscribe(state => {
      this.haveStorm = state;
      let minusHeight = this.isSmallHeader ? this.heightHeaderSmall : this.heightHeaderBig;
      let minusStorm = this.haveStorm ? '- 40px' : '';
      let minusHydroStorm = this.haveHydroStorm ? '- 40px' : '';

      // this.isSmallScreen = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
      // this.isMobileAds = this.breakpointObserver.isMatched('screen and (max-width: 788px)');
      // this.height = `calc(100vh ${!this.isSmallScreen ? `- 71px - 50px ${this.haveStorm ? '- 40px' : ''} ${this.haveHydroStorm ? '- 40px' : ''}` : '- 64px'})`;
      this.height = `calc(100vh - ${minusHeight} ${minusStorm} ${minusHydroStorm})`;
      this.paddingTop = this.isSmallHeader ? `${50 + (this.haveStorm ? 40 : 0) + (this.haveHydroStorm ? 40 : 0)}px` : '0px';
    });
    this._shared.currentHydroStorm.subscribe(state => {
      this.haveHydroStorm = state;
      let minusHeight = this.isSmallHeader ? this.heightHeaderSmall : this.heightHeaderBig;
      let minusStorm = this.haveStorm ? '- 40px' : '';
      let minusHydroStorm = this.haveHydroStorm ? '- 40px' : '';

      // this.isSmallScreen = this.breakpointObserver.isMatched('screen and (max-width: 1000px)');
      // this.isMobileAds = this.breakpointObserver.isMatched('screen and (max-width: 788px)');
      // this.height = `calc(100vh ${!this.isSmallScreen ? `- 71px - 50px ${this.haveStorm ? '- 40px' : ''} ${this.haveHydroStorm ? '- 40px' : ''}` : '- 64px'})`;
      this.height = `calc(100vh - ${minusHeight} ${minusStorm} ${minusHydroStorm})`;
      this.paddingTop = this.isSmallHeader ? `${50 + (this.haveStorm ? 40 : 0) + (this.haveHydroStorm ? 40 : 0)}px` : '0px';
    });
    this._shared.currentLevelWidget.subscribe(state => {
      this.haveLevelWidget = state;
    });
    this._shared.currentHydroStormWidget.subscribe(state => {
      this.haveHydroStormWidget = state;
    });
    this._shared.currentFactWidget.subscribe(state => {
      this.haveFactWidget = state;
    });
  }

}
